const MOTORS_ONLY_PATH_SEGMENT = '/motors-only';
const MOTORS_ONLY_PARAM = 'motors-only';

/**
 * Detect whether the current context is a "motors-only" page, either by
 * pathname segment (BRP: `/cars-vans-motorbikes/cars/uk/motors-only`) or
 * query parameter (SRP: `/search?...&motors-only=true`).
 *
 * On the server side, pass the request pathname explicitly.
 */
export const isMotorsOnlyPage = (pathname?: string, search?: string): boolean => {
    const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
    const query = search ?? (typeof window !== 'undefined' ? window.location.search : '');
    return path.includes(MOTORS_ONLY_PATH_SEGMENT) || query.includes(`${MOTORS_ONLY_PARAM}=true`);
};

/**
 * If the current page is motors-only, set `motors-only=true` on the given
 * URLSearchParams (mutates in place).  Safe to call unconditionally.
 */
export const applyMotorsOnlyParam = (
    params: URLSearchParams,
    pathname?: string,
    search?: string,
): void => {
    if (isMotorsOnlyPage(pathname, search) && !params.has(MOTORS_ONLY_PARAM)) {
        params.set(MOTORS_ONLY_PARAM, 'true');
    }
};
